import { Dialog, DialogContent, DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { BridgeContainer } from '@/features/bridge/BridgeContainer'
import { Typography } from '@/ui/atoms/typography/Typography'
interface TransferDialogProps {
  open: boolean
  setOpen: (open: boolean) => void
}

export function TransferDialog({ open, setOpen }: TransferDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent aria-describedby={undefined} className="px-2">
        <DialogTitle>
          <Typography variant="span" className="ml-3 font-bold text-xl lg:text-4xl" gradient>
            Transfer
          </Typography>
        </DialogTitle>

        <div className="mt-3">
          <BridgeContainer withHeading={false} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
